// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-3d1e003d],.disclaimer[data-v-3d1e003d]{padding:1rem}.actions[data-v-3d1e003d]{list-style:none;margin:0;text-align:center}.action+.action[data-v-3d1e003d]{margin-top:1rem}", ""]);
// Exports
module.exports = exports;
